export default __webpack_public_path__ + "static/media/more_time_silver.0db7fd7d.svg";